<script>
  import BagIcon from "./icons/BagIcon.svelte";

  import * as SettingsDAL from "../dal/settings-dal";

  import { isRtl } from "../utils.js";

  let phoneNumber = "";
  let phoneInput;

  let name = "";
  let nameInput;

  let sent = false;

  function filterInput(e) {
    if (e.keyCode != 13 && (e.keyCode < 48 || e.keyCode > 57)) {
      e.preventDefault();
    } else {
      phoneInput.classList.remove("invalidInput");
    }
  }

  function checkRtl(e) {
    if (isRtl(e.target.value)) {
      e.target.style.direction = "rtl";
    } else {
      e.target.style.direction = "ltr";
    }

    nameInput.classList.remove("invalidInput");
  }

  function send() {
    let valid = true;

    if (!name) {
      nameInput.classList.add("invalidInput");
      valid = false;
    }

    if (phoneNumber.length < 10) {
      phoneInput.classList.add("invalidInput");
      valid = false;
    }

    if (!valid) return;

    SettingsDAL.contact({ name, phoneNumber }).then(() => {
      sent = true;
    });
  }

</script>

<div class="bg">
  <div class="hero">
    <div class="title">
      <h1>מעכשיו גם בעסק שלכם אפשר להזמין ולשלם מהטלפון</h1>
    </div>
    <div class="mockups">
      <img src="images/mockup.png" alt="phone app mockup" />
      <img src="images/mockup2.png" alt="phone app mockup" />
    </div>
  </div>
  <div class="block heroText">
    <h1>למה PickApp?</h1>
    <ul>
      <li>הלקוחות מזמינים ומשלמים מהטלפון</li>
      <li>העובדים שלכם עסוקים פחות בקופה ויותר בשירות ובהכנת הזמנות</li>
      <li>בלי עמלות מיותרות לחברות משלוחים</li>
    </ul>
  </div>

  <div class="how block">
    <h1>איך זה עובד?</h1>
    <div class="steps">
      <div class="step">
        <h2>1</h2>
        <div class="icon"><img src="images/qr-icon.svg" alt="" /></div>
        הלקוחות נכנסים ללינק או סורקים קוד QR שמביא אותם ישירות לעמוד שלכם
        ב-PickApp
      </div>
      <div class="step">
        <h2>2</h2>
        <div class="icon"><img src="images/phone-icon.svg" alt="" /></div>
        תוך דקה (בלי הרשמה!) הם ממלאים הזמנה ומשלמים אונליין
      </div>
      <div class="step">
        <h2>3</h2>
        <div class="icon">
          <BagIcon />
        </div>
        הלקוחות אוספים את ההזמנה כשהיא מוכנה וכולם מרוצים :)
      </div>
    </div>
  </div>
  <!-- <div class="block">
    <h1 class="blockText">
      פיקאפ נותנת לכם כלים שעוזרים לכם להבין איך העסק שלכם עובד
    </h1>
  </div>
  <div class="graphsContainer">
    <div class="graphs">
      <SalesGraph {orders} />
      <SummaryGraph {orders} />
    </div>
  </div> -->
  <div class="form-container">
    <div class="form" data-netlify="true" name="contacts">
      {#if !sent}
        <h1>רוצים להצטרף? מעולה! <br /> השאירו פרטים ונתקשר :)</h1>
        <label for="name">שם</label>
        <input
          name="name"
          id="name"
          maxlength="20"
          type="text"
          bind:value={name}
          bind:this={nameInput}
          on:input={checkRtl}
        />
        <label for="phoneNumber">טלפון</label>
        <input
          name="phone"
          id="phoneNumber"
          maxlength="12"
          inputmode="numeric"
          type="text"
          bind:value={phoneNumber}
          bind:this={phoneInput}
          on:keypress={filterInput}
        />
        <!-- <button type="submit">שליחה</button> -->
        <button on:click={send}>שליחה</button>
      {:else}
        <h1>תודה!</h1>
      {/if}
    </div>
  </div>
</div>

<style>
  .blockText {
    text-align: right;
    width: 100%;
    max-width: unset;
    font-size: 40px;
    max-width: 660px;
    padding-left: 80px;
  }
  .shadow {
    box-shadow: 0 10px 40px -10px #000000;
  }
  .heroText {
    padding: 140px min(220px, 15%) 50px 40px !important;
  }

  .graphsContainer {
    width: 100%;
    background-size: cover;
    background-image: url("../images/contact-graphs-bg.jpg");
    padding-bottom: 140px;
    margin-top: 40px;
  }
  .graphs {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    direction: rtl;
    font-size: 14px;
    color: var(--grey1);
    margin-top: 40px;
  }
  .bg {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    color: white;
    direction: rtl;
  }

  .form-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 150px;
  }

  .form {
    width: 100%;
    padding: 50px;
    border-radius: 7px;
    letter-spacing: 2px;
    margin-top: 6px;
    font-size: 18px;
    font-weight: 700;
    background: white;
    border: none;
    outline: 0;
    color: var(--grey1);
    direction: rtl;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 19px 40px -25px black;
  }

  .form > button {
    cursor: pointer;
  }

  h1 {
    font-family: "Rubik";
    color: var(--grey1);
    font-size: 20px;
    margin-bottom: 0px;
  }

  label {
    font-size: 16px;
    margin-top: 15px;
    color: var(--grey1);
    text-align: right;
  }

  input {
    width: 210px;
    margin: 0;
    padding: 7px 15px 7px 15px;
    direction: ltr;
    -webkit-appearance: none;
    border-radius: 7px;
    letter-spacing: 2px;
    margin-top: 8px;
    text-align: center;
    font-size: 15px;
  }

  input:focus,
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    border: 1.5px solid var(--blue1);
    outline: none;
    background: white;
  }

  button {
    width: 120px;
    height: 60px;
    border-radius: 510px;
    padding: 0;
    margin: 0;
    background: var(--blue1);
    color: white;
    font-size: 22px;
    border: 3px solid white;
    box-shadow: 0 0 0px 3px var(--blue1);
    margin-top: 45px;
  }

  .hero {
    background-image: url("../images/contact2.jpg");
    width: 100%;
    min-height: max(60vh, 400px);
    background-size: cover;
    background-position: bottom;
    padding-bottom: 40px;
  }

  .title {
    width: 100%;
    background: #000000c0;
    padding: 20px;
    margin-top: 15%;
    padding-right: clamp(5%, 30px, 10%);
    font-size: 38px;
    box-sizing: border-box;
  }

  h1 {
    color: inherit;
    font-size: inherit;
    margin: 0;
    max-width: min(36%, 400px);
  }

  .block {
    width: 100%;
    color: var(--grey1);
    font-size: 26px;
    padding: 40px;
    background: white;
    box-sizing: border-box;
    box-shadow: 0px 20px 40px -40px;
  }

  li {
    margin-top: 20px;
  }

  .how {
    padding: 40px;
    margin-top: 100px;
    margin-bottom: 100px;
  }

  .how > h1 {
    width: 100%;
    max-width: unset;
    text-align: center;
  }

  .steps {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    max-width: 1100px;
    flex-wrap: wrap;
    margin-left: auto;
    margin-right: auto;
  }

  .step {
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 15px;
    font-size: 20px;
    text-align: center;
    flex-basis: 25%;
  }

  .icon {
    color: white;
    width: 80px;
    height: 80px;
    margin: 20px;
    background: var(--blue1);
    padding: 30px;
    border-radius: 100%;
    box-shadow: 0 0 0px 4px white, 0 0 0 8px var(--blue1);
  }

  .icon > img {
    width: 100%;
  }

  .mockups {
    position: absolute;
    top: 2%;
    left: 2%;
  }

  .mockups > img {
    width: min(20%, 310px);
    width: clamp(150px, 30%, 280px);
    float: left;
  }

  @media only screen and (max-width: 820px) {
    .mockups > img:nth-child(1) {
      display: none;
    }

    .mockups > img:nth-child(2) {
      width: 58%;
    }

    h1 {
      max-width: min(40%, 306px);
    }
  }

  @media only screen and (max-width: 586px) {
    .mockups > img:nth-child(2) {
      display: none;
    }

    h1 {
      max-width: 70%;
    }
  }

</style>
